import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

import * as jwt_decode from 'jwt-decode';
import { Observable, of, timer, interval } from 'rxjs';
import { AppConfig } from '../config/app-config';
import { publishReplay, refCount, take, delay, flatMap, exhaustMap } from 'rxjs/operators';
export const TOKEN_NAME: string = 'ActivatorToken';


@Injectable({
    providedIn: 'root',
})
export class AuthService {

    procesingToken = false;
    nextTokenGeneration = new Date();

    constructor(private http: HttpClient, private appConfig: AppConfig) {
        this.nextTokenGeneration.setMinutes(this.nextTokenGeneration.getMinutes() + 1);
    }

    refreshToken() {
        var dateNow = new Date();
        if (this.nextTokenGeneration < dateNow && !this.procesingToken) {
            this.procesingToken = true;
            this.setRefreshToken().subscribe(x => { this.procesingToken = false; this.setToken(x.token); this.nextTokenGeneration.setMinutes(dateNow.getMinutes() + 1); }
                , err => { this.procesingToken = false; this.nextTokenGeneration.setMinutes(this.nextTokenGeneration.getMinutes() + 1); });
        }
    }

    setRefreshToken(): Observable<any> {
        let params = new HttpParams()
            .set("login", this.getLoginFromToken() ?? '')

        return this.http.get<any>(this.appConfig.urlKeysApi + 'User/RefreshToken', { params: params });


    }

    getToken(): string {
        return localStorage.getItem(TOKEN_NAME);
    }

    removeToken() {
        localStorage.removeItem(TOKEN_NAME);
    }

    setToken(token: string): void {
        localStorage.setItem(TOKEN_NAME, token);
    }

    getUserFromToken(): any {
        const decoded = jwt_decode(this.getToken());
        return decoded;
    }

    getLoginFromToken(): string {
        const decoded = jwt_decode(this.getToken());
        return decoded.Login;
    }

    getRolFromToken(): string {
        const decoded = jwt_decode(this.getToken());
        return decoded.RoleId;
    }

    getTokenExpirationDate(token: string): Date {
        const decoded = jwt_decode(token);
        if (decoded.exp === undefined)
            return null;
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    isTokenExpired(token?: string): boolean {
        if (!token)
            token = this.getToken();
        if (token === 'undefined' || !token)
            return true;
        const date = this.getTokenExpirationDate(token);
        if (date === undefined)
            return false;
        return !(date.valueOf() > new Date().valueOf());
    }
}
